import { render, staticRenderFns } from "./SingleBoardInformationModal.vue?vue&type=template&id=0563baf5&"
import script from "./SingleBoardInformationModal.vue?vue&type=script&lang=ts&"
export * from "./SingleBoardInformationModal.vue?vue&type=script&lang=ts&"
import style0 from "./SingleBoardInformationModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports